// 获取验证码 type:1登录，2认证，3注册
export const getSmsCode = ($axios, data) => {
  return $axios({
    url: '/sms-code',
    method: 'post',
    data
  }).then(res => res.data)
}
// 获取邮箱验证码 type:1登录，2认证，3注册
export const getEmailCode = ($axios, data) => {
  return $axios({
    url: '/email-code',
    method: 'post',
    data
  }).then(res => res.data)
}
// ======================新的接口写在上面=======================
// 获取验证码 type:1登录，2认证，3注册
export const smsCode = vmParam => {
  return {
    url: '/sms-code',
    method: 'post',
    data: vmParam
  }
}
// 检验验证码
export const checkSms = vmParam => {
  return {
    url: '/sms-code',
    method: 'patch',
    data: vmParam
  }
}
// 检验邮箱验证码
export const checkEmail = vmParam => {
  return {
    url: '/email-code',
    method: 'patch',
    data: vmParam
  }
}
// 注册商户账号
export const newSignUp = ($axios, data) =>
  $axios({
    url: '/v2/sign-up',
    method: 'post',
    data
  }).then(res => res.data)
// 获取省
// export const states = regionId => {
//   return {
//     url: `/region/${regionId}/states`,
//     method: 'get'
//   }
// }
// // 获取市
// export const cities = vmParam => {
//   return {
//     url: `/region/${vmParam.regionId}/state/${vmParam.stateId}/cities`,
//     method: 'get'
//   }
// }

// 获取备货仓  /platform-warehouses
export const warehouses = vmParam => {
  return {
    url: '/platform-warehouses',
    method: 'get',
    params: vmParam
  }
}
// 申请备货仓
export const platformwarehouse = vmParam => {
  return {
    url: '/platform-warehouse-apply',
    method: 'post',
    data: vmParam
  }
}
// 申请卖家自有仓
export const sellerwarehouse = vmParam => {
  return {
    url: '/seller-warehouse-apply',
    method: 'post',
    data: vmParam
  }
}
// 获取卖家自有仓
export const getsellerwaerhouse = vmParam => {
  return {
    url: '/seller-warehouse-apply',
    method: 'get',
    params: vmParam
  }
}
// 上架商品的Subordinate Type
// export const Subordinatetype = () => {
//     return {
//         url:'https://apis.perfee.net/mock/30/category-tree',
//         method:'get'
//     }
// }
// 获取规格属性
// export const getpropspec = vmParam => {
//     return {
//         url:`https://apis.perfee.net/mock/30/category/${vmParam}/props-specs`,
//         method:'get'
//     }
// }
// 获取属性规格的值
// export const getspecvalue = vmParam => {
//     return {
//         url:'https://apis.perfee.net/mock/30/prop-spec-values',
//         method:'get',
//         params:vmParam
//     }
// }
// 获取店铺列表
export const getstorelist = () => {
  return {
    url: '/stores',
    method: 'get'
  }
}
// 获取店铺列表
export const getstorelistByType = (params) => {
  return {
    url: '/v1/store/applications',
    params,
    method: 'get'
  }
}
// 获取店铺设置信息     https://apis.perfee.net/mock/30/store-settings
export const getStoreMessage = () => {
  return {
    url: '/store-settings',
    method: 'get'
  }
}
// 店铺设置
export const storesetting = vmParam => {
  return {
    url: '/store-settings',
    method: 'patch',
    data: vmParam
  }
}
// 对话消息列表
export const talks = vmParam => {
  return {
    url: '/talks',
    method: 'get',
    params: vmParam
  }
}
// 获取对话内容
export const getTalks = (talkId, vmParam) => {
  return {
    url: `/talk/${talkId}/messages`,
    method: 'get',
    params: vmParam
  }
}
// 发送消息
export const sendMessage = vmParam => {
  return {
    url: '/talk/msg',
    method: 'post',
    data: vmParam
  }
}
// 获取店内商品分类  https://apis.perfee.net/mock/30/store-categories
export const goodsCategory = vmParam => {
  return {
    url: '/store-categories',
    method: 'get',
    params: vmParam
  }
}
// 获取品牌列表  /brands
export const brands = vmParam => {
  return {
    url: '/brands',
    method: 'get',
    params: vmParam
  }
}
// 添加店内商品分类 addProduct    /${storeId}/categories
export const addProduct = vmParam => {
  return {
    url: '/store-categories',
    method: 'post',
    data: vmParam
  }
}
// 修改店内商品分类   /${storeId}/categories
export const alterProduct = vmParam => {
  return {
    url: '/store-categories',
    method: 'patch',
    data: vmParam
  }
}
// 删除店内商品分类  /${storeId}/categories
export const deteleProdut = vmParam => {
  return {
    url: '/store-categories',
    method: 'delete',
    data: vmParam
  }
}
// 获取商品管理列表
export const getProductList = vmParam => {
  return {
    url: '/goods-management',
    method: 'get',
    params: vmParam
  }
}
// 获取商品预警原因
export const getWarningReasons = vmParam => {
  return {
    url: '/basegoods/v1/listings/warning-reasons',
    method: 'get',
    params: vmParam
  }
}
// 获取商品列表数量
export const getProductNum = vmParam => {
  return {
    url: '/goods-management-count',
    method: 'get',
    params: vmParam
  }
}
// 操作商品 apply
export const setApplyActive = id => {
  return {
    url: `/apply-goods-activation/${id}`,
    method: 'patch'
  }
}
// 批量操作商品 申请上架
export const setBatchApplyActive = vmParam => {
  return {
    url: `/bat-apply-goods-activation`,
    data: vmParam,
    method: 'post'
  }
}
// 获取用户可用的优惠券
export const getVoucherList = vmParam => {
  return {
    url: '/voucher-gens',
    method: 'get',
    params: vmParam
  }
}

// CPS management
export const getCpsStoreDefaults = params => ({
  url: '/cps/store-defaults',
  method: 'get',
  params
})

export const saveCpsStoreDefaults = data => ({
  url: '/cps/store-defaults',
  method: 'put',
  data
})

export const getCpsProductConfigs = params => ({
  url: '/cps/product-configs',
  method: 'get',
  params
})

export const saveCpsProductConfig = (listingId, data) => ({
  url: `/cps/product-configs/${listingId}`,
  method: 'put',
  data,
  validateStatus: status => (status >= 200 && status < 300)
    || [400, 403, 404, 409].includes(status)
})

export const replaceCpsVoucherBinding = (listingId, data) => ({
  url: `/cps/product-configs/${listingId}`,
  method: 'patch',
  data,
  validateStatus: status => (status >= 200 && status < 300)
    || [400, 403, 404, 409].includes(status)
})

export const requestCloseCpsProduct = (listingId, data) => ({
  url: `/cps/product-configs/${listingId}/close`,
  method: 'put',
  data
})

export const withdrawCloseCpsProduct = (listingId, data) => ({
  url: `/cps/product-configs/${listingId}/close-withdrawal`,
  method: 'put',
  data
})

export const batchOperateCpsProducts = data => ({
  url: '/cps/product-configs/batch',
  method: 'put',
  data
})

export const getCpsDashboard = params => ({
  url: '/marketing/v1/cps/seller/dashboard',
  method: 'get',
  params
})

export const exportCpsCommissionOrders = params => ({
  url: '/marketing/v1/cps/seller/commission-orders/export',
  method: 'get',
  params,
  responseType: 'blob',
  validateStatus: status => status >= 200 && status < 600
})

export const getCpsCommissionOrders = params => ({
  url: '/marketing/v1/cps/seller/commission-orders',
  method: 'get',
  params,
  validateStatus: status => (status >= 200 && status < 300)
    || [400, 403, 503].includes(status)
})

// 获取已删除的商品管理列表
export const deletedProductList = vmParam => {
  return {
    url: '/deleted-goods-management',
    method: 'get',
    params: vmParam
  }
}
// 获取商品详情
export const getProductDetails = vmParam => {
  return {
    url: '/goods-manage-detail',
    method: 'get',
    params: vmParam
  }
}

// 获取Listing
export const getListing = vmParam => {
  return {
    url: '/edit-listing',
    method: 'get',
    params: vmParam
  }
}
// 批量设置商品所支持的支付方式
export const batchUpdatePaymentMethod = vmParam => {
  return {
    url: '/batch-update-payment-method',
    method: 'patch',
    data: vmParam
  }
}
// 获取店铺可以使用的仓库
export const getWarehouse = vmParam => {
  return {
    url: '/usable-warehouses',
    method: 'get',
    params: vmParam
  }
}
// 更新Listing
export const updateListing = vmParam => {
  return {
    url: '/edit-listing',
    method: 'patch',
    data: vmParam
  }
}
// 上架、下架、改价
export const changeSku = vmParam => {
  return {
    url: '/update-sku-status',
    method: 'patch',
    data: vmParam
  }
}
// 获取sku
export const getSku = vmParam => {
  return {
    url: '/edit-sku',
    method: 'get',
    params: vmParam
  }
}
// 更新sku
export const updateSku = vmParam => {
  return {
    url: '/edit-sku',
    method: 'patch',
    data: vmParam
  }
}
// 发布商品
// export const releaseCommit = vmParam => {
//     return {
//         url:'/new-goods',
//         method:'post',
//         data:vmParam
//     }
// }
// 获取销售订单列表
export const getOrderList = vmParam => {
  return {
    url: '/sales-order',
    method: 'get',
    params: vmParam
  }
}
// 获取新订单列表
export const getNewOrderList = vmParam => {
  return {
    url: '/order-list',
    method: 'get',
    params: vmParam
  }
}
// 导出新订单列表
export const exportNewOrderList = vmParam => {
  return {
    url: '/order-list-download',
    method: 'get',
    params: vmParam
  }
}
// 导出订单列表
export const exportOrderList = vmParam => {
  return {
    url: '/sales-order-download',
    method: 'get',
    params: vmParam
  }
}
// 获取销售订单详情
export const getOrderDetails = vmParam => {
  return {
    url: '/sales-order-detail',
    method: 'get',
    params: vmParam
  }
}
// 获取新订单详情
export const getNewOrderDetails = vmParam => {
  return {
    url: '/order-detail',
    method: 'get',
    params: vmParam
  }
}
// 人工确认订单
export const confirmationoforder = vmParam => {
  return {
    url: '/sales-order-detail',
    method: 'patch',
    data: vmParam
  }
}
// 人工取消订单
export const cancelationoforder = vmParam => {
  return {
    url: '/cancel-order',
    method: 'patch',
    data: vmParam
  }
}
// 下载销售订单详情
export const downloadOrder = vmParam => {
  return {
    url: '/sales-order-download',
    method: 'get',
    params: vmParam
  }
}
// 获取发运包列表
export const getDispatchOrder = vmParam => {
  return {
    url: '/packages',
    method: 'get',
    params: vmParam
  }
}
// 下载发运包
export const downloadDispatch = vmParam => {
  return {
    url: '/packages_1566199735523',
    method: 'get',
    params: vmParam
  }
}
// 获取发运包详情
export const getDispatchDetails = vmParam => {
  return {
    url: `/package-detail/${vmParam}`,
    method: 'get'
  }
}
// 发货
export const shipmentsStart = vmParam => {
  return {
    url: '/package-operation',
    method: 'patch',
    data: vmParam
  }
}
// 取消发货
export const Canceldelivery = vmParam => {
  return {
    url: '/cancel-order',
    method: 'patch',
    data: vmParam
  }
}
// 获取账户列表
export const staffList = vmParam => {
  return {
    url: '/staff-list',
    method: 'get',
    params: vmParam
  }
}
// 修改员工账号信息
export const staffUpdate = (staffId, vmParam) => {
  return {
    url: `/staff/${staffId}/update`,
    method: 'patch',
    data: vmParam
  }
}

// 获取国内发货中转仓
export const getTransferWarehouses = () => {
  return {
    url: '/transfer-warehouses',
    method: 'get'
  }
}

// 批量填写国内运单
export const batchFillPackages = vmParam => {
  return {
    url: '/packages',
    method: 'patch',
    data: vmParam
  }
}

export const prepaymentSite = vmParam => {
  return {
    url: `/listing/${vmParam.listingId}/prepayment`,
    method: 'patch',
    data: vmParam.params
  }
}

// ---------------------
// 通过 parent_id 获取下级城市
export const getAreaByParentId = ($axios, pid) => $axios
  .get(`/area/${pid}/areas`)
  .then(r => r.data?.data?.areas || [])

export const getSubsidiariesUsable = ($axios) => $axios
  .get('/store/localized-subsidiaries/usable')
  .then(r => r.data?.data)

export const getStorePostage = ($axios, rid) => $axios
  .get(`/product/store-postage?regionId=${rid}`)
  .then(r => r.data?.data)

export const putStorePostage = ($axios, params) => $axios
  .put('/product/store-postage', params)
  .then(r => r.data?.data)

// 获取省市级数
export const getAreaRegions = ($axios, params) => $axios
  .get(`/area/regions`, { params })
  .then(r => r.data?.data?.regions || [])

// 人工确认订单
export const processOrderManually = ($axios, params) => $axios
  .patch('/sales-order-detail', params)
  .then(r => r.data?.data)

export const productPostage = ($axios, params) => $axios
  .get('/product/postage', { params })
  .then(r => r.data?.data)

export const putProductPostage = ($axios, params) => $axios
  .put('/product/postage', params)
  .then(r => r.data?.data)

export const checkBusinessLicense = ($axios, params) => $axios
  .post('/logistics-account/check-business-license', params)
  .then(r => r.data?.data)

// 获取所有类目（一级、二级及三级所属关系)
export const getAllCategory = ($axios, params) => $axios
  .get('/categories', { params })
  .then(r => r.data?.data)

// 获取菜单列表数据
export const getMenuAllListData = ($axios, params) => $axios
  .get('/seller/menus', { params })
  .then(r => r.data?.data)

// 获取订单取消原因
export const getOrderCancellationReason = (orderSn) => {
  return {
    url: `/order-cancellation-reason/${orderSn}`,
    method: 'get'
  }
}
// 获取订单取消原因
export const getOrderCancelReasons = () => {
  return {
    url: `/cancel-reasons`,
    method: 'get'
  }
}
